/* ============================================================
   arthene — Warenkorb

   Mengen ändern und Werke entfernen laufen über Shopifys Cart-AJAX-API
   (/cart/change.js). Die Seite wird dabei NICHT neu geladen: Shopify
   liefert über die Section-Rendering-API dieselbe Section frisch
   gerendert zurück, wir tauschen nur den Inhalt aus. Ohne JavaScript
   funktioniert alles trotzdem — dann greift das normale Formular
   (POST /cart) mit den „Aktualisieren"-Knöpfen.

   Jede Änderung meldet außerdem die neue Stückzahl an alle
   [data-arthene-cart-count] im Kopf.
   ============================================================ */
(function () {
  'use strict';

  var WURZEL = '[data-korb]';

  function korb() { return document.querySelector(WURZEL); }

  /* Shopify setzt window.Shopify.routes.root über content_for_header.
     Der Rückfall hält die Datei auch außerhalb der Storefront lauffähig. */
  function wurzelPfad() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function zaehlerSetzen(anzahl) {
    document.querySelectorAll('[data-arthene-cart-count]').forEach(function (el) {
      el.textContent = anzahl;
      /* Ausgeblendet wird ueber das hidden-Attribut — so macht es Liquid beim
         Aufbau der Seite (arthene-masthead.liquid) und so blendet es
         .cart-link__count[hidden] aus. Die frueher gesetzte Klasse is-leer
         gibt es in keinem Stylesheet; nach dem Entfernen des letzten Werks
         blieb deshalb eine sichtbare "0" in der Leiste stehen. */
      if (anzahl === 0) {
        el.setAttribute('hidden', '');
      } else {
        el.removeAttribute('hidden');
      }
    });
  }

  function statusSetzen(text) {
    var el = document.querySelector('[data-korb-status]');
    if (el) el.textContent = text || '';
  }

  /* Die Meldungstexte haengen als data-Attribute an eben diesem Absatz
     (s. sections/arthene-warenkorb.liquid). Eine .js-Datei rendert kein
     Liquid und kennt die Sprache des Shops nicht; Liquid kennt sie. Der
     deutsche Rueckfall haelt die Datei auch ausserhalb der Storefront und
     nach einem unvollstaendigen Neuaufbau der Section lauffaehig. */
  function meldungstext(name, rueckfall) {
    var el = document.querySelector('[data-korb-status]');
    return (el && el.getAttribute('data-' + name)) || rueckfall;
  }

  /* Ersetzt den Warenkorb durch die frisch gerenderte Section aus der Antwort. */
  function neuZeichnen(html) {
    var wurzel = korb();
    if (!wurzel || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var neu = doc.querySelector(WURZEL);
    if (!neu) { window.location.reload(); return; }
    wurzel.replaceWith(neu);
    binden();
  }

  /* Immer nur eine Aenderung unterwegs. Zweimal schnell auf „+" schickte
     sonst zwei Anfragen mit hier hochgezaehlten Mengen los; wessen Antwort
     zuletzt eintraf, zeichnete den Korb neu — eine aeltere Antwort konnte die
     neuere ueberschreiben. Schlimmer noch beim Entfernen: faellt eine Zeile
     weg, verschieben sich die Zeilennummern, und die zweite Anfrage traf das
     falsche Werk. Klicks waehrend einer laufenden Anfrage werden ignoriert;
     aendern() sagt mit false, dass nichts geschickt wurde. */
  var laeuft = false;

  function aendern(zeile, menge, zeilenEl) {
    var wurzel = korb();
    if (!wurzel || laeuft) return false;
    var sectionId = wurzel.dataset.korb;
    laeuft = true;
    if (zeilenEl) zeilenEl.setAttribute('aria-busy', 'true');
    statusSetzen('');

    fetch(wurzelPfad() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: zeile,
        quantity: menge,
        sections: sectionId,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (daten) {
        laeuft = false;
        if (daten.status) {                       /* Shopify meldet einen Fehler */
          if (zeilenEl) zeilenEl.removeAttribute('aria-busy');
          statusSetzen(daten.description || daten.message ||
            meldungstext('fehler-menge', 'Die Menge konnte nicht geändert werden.'));
          return;
        }
        zaehlerSetzen(daten.item_count);
        if (daten.sections && daten.sections[sectionId]) {
          neuZeichnen(daten.sections[sectionId]);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        laeuft = false;
        if (zeilenEl) zeilenEl.removeAttribute('aria-busy');
        statusSetzen(meldungstext('fehler-verbindung',
          'Verbindung unterbrochen — bitte laden Sie die Seite neu.'));
      });

    return true;
  }

  function binden() {
    var wurzel = korb();
    if (!wurzel || wurzel.dataset.bereit === '1') return;
    wurzel.dataset.bereit = '1';

    /* Ist JS da, brauchen die „Aktualisieren"-Knöpfe des Formulars niemand. */
    wurzel.querySelectorAll('[data-korb-submit]').forEach(function (b) { b.hidden = true; });

    wurzel.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-menge-minus]');
      var plus = e.target.closest('[data-menge-plus]');
      var weg = e.target.closest('[data-korb-entfernen]');
      if (!minus && !plus && !weg) return;
      e.preventDefault();

      var zeilenEl = e.target.closest('[data-zeile]');
      if (!zeilenEl) return;
      var zeile = parseInt(zeilenEl.dataset.zeile, 10);

      if (weg) { aendern(zeile, 0, zeilenEl); return; }

      var feld = zeilenEl.querySelector('[data-menge-feld]');
      var jetzt = parseInt(feld.value, 10) || 0;
      var neu = plus ? jetzt + 1 : jetzt - 1;
      if (neu < 0) neu = 0;
      /* Das Feld erst hochsetzen, wenn die Anfrage auch wirklich rausgeht —
         sonst zeigte es waehrend einer laufenden Aenderung eine Menge an,
         die niemand bestellt hat. */
      if (aendern(zeile, neu, zeilenEl)) feld.value = neu;
    });

    /* Direkte Eingabe im Zahlenfeld */
    wurzel.addEventListener('change', function (e) {
      var feld = e.target.closest('[data-menge-feld]');
      if (!feld) return;
      var zeilenEl = feld.closest('[data-zeile]');
      var menge = parseInt(feld.value, 10);
      if (isNaN(menge) || menge < 0) menge = 0;
      aendern(parseInt(zeilenEl.dataset.zeile, 10), menge, zeilenEl);
    });

    /* Bestellnotiz still im Hintergrund sichern */
    var notiz = wurzel.querySelector('[data-korb-notiz]');
    if (notiz) {
      var timer;
      notiz.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          fetch(wurzelPfad() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: notiz.value })
          }).catch(function () {});
        }, 600);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', binden);
  document.addEventListener('shopify:section:load', function () {
    var w = korb();
    if (w) { w.dataset.bereit = ''; binden(); }
  });
  if (document.readyState !== 'loading') binden();
})();
